/* eslint-disable */
/* eslint-disable camelcase */
import * as React from 'react';
import { useForm } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { IconButton, InputAdornment, Stack, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import swal from 'sweetalert';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import {
  addTrainingPackage,
  dropDownOffering,
  dropDownServiceMaster,
  getAddonsDropDownData,
  dropDownLesson,
} from '../../common/api-service';
import { GroomingContext } from 'src/layouts/dashboard';

function AddDogTraining() {
  const navigate = useNavigate();
  const groomingData = useContext(GroomingContext);
  const theme = useTheme();

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const pet_types = ['Dog', 'Cat'];
  const Packages_status = ['active', 'disabled'];

  function getStyles(type, Name, theme) {
    return {
      fontWeight: Name.indexOf(type) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
    };
  }
  function getStyles1(type, Name, theme) {
    return {
      fontWeight: theme.typography.fontWeightRegular,
    };
  }

  const [AdminNotes, setAdminNotes] = useState('');
  const [packagesDiscription, setPackagesDiscription] = useState('');
  const [loading, setLoading] = useState(false);
  const [packagefieldCount, setPackageFieldCount] = useState([]);
  const [packageLessonfieldCount, setPackageLessonFieldCount] = useState([]);
  const [userName, setUserName] = useState('');
  const [petName, setPetName] = React.useState([]);
  const [PackagesStatus, setStatus] = React.useState([]);
  const [data, setData] = useState([]);
  const [packagePrice, setPackagePrice] = React.useState('');
  const [NumberOfPets, setNumberOfPets] = React.useState('');
  const [validityDay, setValidityDay] = React.useState([]);
  const [validitySession, setValiditySession] = React.useState([]);
  const [checked, setChecked] = React.useState(false);
  const [offerPrice, setOfferPrice] = React.useState('');
  const [numberOfSession, setNumberOfSession] = React.useState('');
  const [afterNoSessions, setAfterNoSessions] = React.useState('');
  const [freeTrialSessions, setFreeTrialSessions] = React.useState('');
  const [extraLessonForFree, setExtraLessonsForFree] = React.useState([]);
  const [lessonsdata, setLessonData] = React.useState([]);

  const handleAdd = () => {
    const abc = [...packagefieldCount, []];
    setPackageFieldCount(abc);
  };

  const addNewhandleChange = (onChangevalue, i) => {
    const inputData = [...packagefieldCount];
    inputData[i] = onChangevalue.target.value;
    setPackageFieldCount(inputData);
  };

  const handleDelete = (i) => {
    const deleteVal = [...packagefieldCount];
    deleteVal.splice(i, 1);
    setPackageFieldCount(deleteVal);
  };

  const handleAddLesson = () => {
    const abc = [...packageLessonfieldCount, []];
    setPackageLessonFieldCount(abc);
  };
  const addNewhandleChangeLesson = (onChangevalue, i) => {
    const inputDataLesson = [...packageLessonfieldCount];
    inputDataLesson[i] = onChangevalue.target.value;
    setPackageLessonFieldCount(inputDataLesson);
  };

  const addNewhandleChangeNumberSession = (onChangevalue, i) => {
    let inputDataLesson = [...packageLessonfieldCount];
    inputDataLesson[i].push({ after_no_of_sessions: onChangevalue.target.value });

    setPackageLessonFieldCount(inputDataLesson);
  };

  const handleDeleteLesson = (i) => {
    const deleteVal = [...packageLessonfieldCount];
    deleteVal.splice(i, 1);
    setPackageLessonFieldCount(deleteVal);
  };

  const lessonDropDown = (payload) => {
    return dropDownLesson(payload).then(
      (res) => {
        setLessonData(res.data.data);
      },
      (err) => {
        console.log('err data: ', err);
      }
    );
  };

  useEffect(() => {
    lessonDropDown();
  }, []);

  const handleClearClick = () => {
    setAdminNotes('');
    setUserName('');
    setPackagesDiscription('');
    setStatus('');
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'all',
  });

  const onSubmit = () => {
    setLoading(true);
    const payload = {
      title: userName,
      description: packagefieldCount,
      admin_notes: AdminNotes,
      lessons: packageLessonfieldCount,
      target_pet: petName,
      price: packagePrice,
      number_of_pets: NumberOfPets === '' ? 0 : NumberOfPets,
      validity_in_days: validityDay === '' ? 0 : validityDay,
      validity_for_sessions: validitySession === '' ? 0 : validitySession,
      offer_price: offerPrice,
      number_of_sessions: numberOfSession === '' ? 0 : numberOfSession,
      free_trial_sessions: freeTrialSessions === '' ? 0 : freeTrialSessions,
      extra_lessons_for_free: extraLessonForFree,
      status: PackagesStatus,
    };

    return addTrainingPackage(payload).then(
      (res) => {
        if (res.data.status === true) {
          setLoading(false);
          navigate('/dashboard/dogTraining', { replace: true });
          swal({
            title: res.data.message,
            icon: 'success',
            timer: 2000,
            button: false,
          });
        } else {
          swal({
            title: res.data.message,
            icon: 'danger',
            timer: 2000,
            button: false,
          });
        }
      },
      (err) => {
        console.log('err', err);
      }
    );
  };

  return (
    <div>
      <Grid>
        <Typography
          variant="h3"
          component="div"
          sx={{
            '& > :not(style)': { width: '25ch' },
          }}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          Add Dog Training Package
        </Typography>
      </Grid>
      <Card>
        <CardContent>
          <Box component="form" minHeight="50vh" noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={3}>
              <Grid container>
                <Grid item xs={12} sm={12}>
                  {/* Title */}
                  <Grid
                    sx={{
                      mt: 3,
                    }}
                  >
                    <TextField
                      id="outlined-basic"
                      label="Title"
                      variant="outlined"
                      value={userName}
                      name="title"
                      required
                      {...register('title', {
                        required: true,
                      })}
                      onChange={(e) => setUserName(e.target.value)}
                      style={{ width: '100%' }}
                    />
                    {errors.title && errors.title.type === 'required' && (
                      <p className="text-danger" style={{ color: 'red' }}>
                        *required
                      </p>
                    )}
                  </Grid>

                  <Grid
                    sx={{
                      mt: 3,
                    }}
                  >
                    <Button variant="contained" onClick={() => handleAddLesson()} sx={{ mb: 3 }}>
                      Add Lessons
                    </Button>

                    {packageLessonfieldCount.map((lessons, i) => {
                      return (
                        <Grid sx={{ mt: 3 }}>
                          <FormControl sx={{ minWidth: '100%', mt: 3 }}>
                            <InputLabel id="demo-multiple-chip-label">Lessons</InputLabel>
                            <Select
                              labelId="demo-multiple-chip-label"
                              id="demo-multiple-chip"
                              multiple
                              value={lessons}
                              onChange={(e) => {
                                addNewhandleChangeLesson(e, i);
                              }}
                              input={<OutlinedInput id="select-multiple-chip" label="Lessons" />}
                              MenuProps={MenuProps}
                            >
                              {lessonsdata.map((e) => {
                                return (
                                  <MenuItem key={e._id} value={e} style={getStyles1(e, lessons, theme)}>
                                    {e.title}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>

                          {/* After Number of Session */}
                          <Grid
                            sx={{
                              mt: 3,
                            }}
                          >
                            <TextField
                              id="outlined-basic"
                              label="After Number of Session"
                              variant="outlined"
                              value={afterNoSessions[i]}
                              onChange={(e) => addNewhandleChangeNumberSession(e, i)}
                              style={{ width: '100%' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Button
                                      sx={{ mt: 2 }}
                                      aria-label="Delete"
                                      edge="end"
                                      color="error"
                                      variant="outlined"
                                      onClick={() => handleDeleteLesson(i)}
                                    >
                                      Delete
                                    </Button>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                        </Grid>
                      );
                    })}
                  </Grid>

                  {/* Extra Lesson For Free */}
                  <Grid>
                    <FormControl sx={{ minWidth: '100%', mt: 3 }}>
                      <InputLabel id="demo-multiple-chip-label">Extra Lessons For Free</InputLabel>
                      <Select
                        labelId="demo-multiple-chip-label"
                        id="demo-multiple-chip"
                        multiple
                        value={extraLessonForFree}
                        onChange={(e) => {
                          setExtraLessonsForFree(e.target.value);
                        }}
                        input={<OutlinedInput id="select-multiple-chip" label="Extra Lessons For Free" />}
                        MenuProps={MenuProps}
                      >
                        {lessonsdata.map((e) => (
                          <MenuItem key={e._id} value={e} style={getStyles(e, extraLessonForFree, theme)}>
                            {e.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Free Trial Sessions */}

                  <Grid
                    sx={{
                      mt: 3,
                    }}
                  >
                    <TextField
                      id="outlined-basic"
                      label="Free Session"
                      variant="outlined"
                      value={freeTrialSessions}
                      onChange={(e) => setFreeTrialSessions(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </Grid>

                  {/* Validity Sessions */}

                  <Grid
                    sx={{
                      mt: 3,
                    }}
                  >
                    <TextField
                      id="outlined-basic"
                      label="Validity Session"
                      variant="outlined"
                      value={validitySession}
                      onChange={(e) => setValiditySession(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </Grid>

                  {/* Number of Session */}
                  <Grid
                    sx={{
                      mt: 3,
                    }}
                  >
                    <TextField
                      id="outlined-basic"
                      label="Number of Session"
                      variant="outlined"
                      value={numberOfSession}
                      onChange={(e) => setNumberOfSession(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </Grid>

                  {/* Number of Pets */}
                  <Grid
                    sx={{
                      mt: 3,
                    }}
                  >
                    <TextField
                      id="outlined-basic"
                      label="Number of Pets"
                      type="number"
                      variant="outlined"
                      value={NumberOfPets}
                      onChange={(e) => setNumberOfPets(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </Grid>

                  {/* Discription */}
                  <Grid
                    sx={{
                      mt: 3,
                    }}
                  >
                    <Button variant="contained" onClick={() => handleAdd()} sx={{ mb: 3 }}>
                      Add Description
                    </Button>

                    {packagefieldCount.map((description, i) => {
                      return (
                        <Grid sx={{ mt: 3 }}>
                          <TextField
                            id="outlined-basic"
                            label="Description"
                            variant="outlined"
                            value={description}
                            onChange={(e) => {
                              addNewhandleChange(e, i);
                            }}
                            style={{ width: '100%' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Button
                                    aria-label="Delete"
                                    edge="end"
                                    color="error"
                                    variant="outlined"
                                    onClick={() => handleDelete(i)}
                                  >
                                    Delete
                                  </Button>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>

                  {/* Admin Notes */}
                  <Grid
                    sx={{
                      mt: 3,
                    }}
                  >
                    <TextareaAutosize
                      id="outlined-basic"
                      minRows={3}
                      label="Admin Notes"
                      variant="outlined"
                      value={AdminNotes}
                      placeholder="Admin Notes"
                      onChange={(e) => setAdminNotes(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </Grid>

                  {/* Pet Type */}
                  <Grid>
                    <FormControl sx={{ minWidth: '100%', mt: 3 }}>
                      <InputLabel id="demo-multiple-chip-label">Pet Type</InputLabel>
                      <Select
                        labelId="demo-multiple-chip-label"
                        id="demo-multiple-chip"
                        multiple
                        value={petName}
                        onChange={(e) => {
                          setPetName(e.target.value);
                        }}
                        input={<OutlinedInput id="select-multiple-chip" label="Pet Type" />}
                        MenuProps={MenuProps}
                      >
                        {pet_types.map((target_pet) => (
                          <MenuItem key={target_pet} value={target_pet} style={getStyles(target_pet, petName, theme)}>
                            {target_pet}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Price */}
                  <Grid
                    sx={{
                      mt: 3,
                    }}
                  >
                    <TextField
                      id="outlined-basic"
                      label="Price"
                      variant="outlined"
                      name="price"
                      required
                      value={packagePrice}
                      {...register('price', {
                        required: true,
                      })}
                      onChange={(e) => setPackagePrice(e.target.value)}
                      style={{ width: '100%' }}
                    />
                    {errors.price && errors.price.type === 'required' && (
                      <p className="text-danger" style={{ color: 'red' }}>
                        *required
                      </p>
                    )}
                  </Grid>

                  {/* Offer Price */}
                  <Grid
                    sx={{
                      mt: 3,
                    }}
                  >
                    <TextField
                      id="outlined-basic"
                      label="Offer Price"
                      variant="outlined"
                      name="offerPrice"
                      required
                      value={offerPrice}
                      {...register('offerPrice', {
                        required: true,
                      })}
                      onChange={(e) => setOfferPrice(e.target.value)}
                      style={{ width: '100%' }}
                    />
                    {errors.offerPrice && errors.offerPrice.type === 'required' && (
                      <p className="text-danger" style={{ color: 'red' }}>
                        *required
                      </p>
                    )}
                  </Grid>

                  {/* Validity */}
                  <Grid
                    sx={{
                      mt: 3,
                    }}
                  >
                    <TextField
                      id="outlined-basic"
                      label="Validity In Days"
                      variant="outlined"
                      value={validityDay}
                      onChange={(e) => setValidityDay(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </Grid>
                  {/* Status */}
                  <Grid>
                    <FormControl sx={{ minWidth: '100%', mt: 3 }}>
                      <InputLabel id="demo-multiple-chip-label">Status</InputLabel>
                      <Select
                        labelId="demo-multiple-chip-label"
                        id="demo-multiple-chip"
                        // multiple
                        value={PackagesStatus}
                        onChange={(e) => {
                          setStatus(e.target.value);
                        }}
                        input={<OutlinedInput id="select-multiple-chip" label="Status" />}
                        MenuProps={MenuProps}
                      >
                        {Packages_status.map((Packages_status) => (
                          <MenuItem
                            key={Packages_status}
                            value={Packages_status}
                            style={getStyles(Packages_status, PackagesStatus, theme)}
                          >
                            {Packages_status}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid sx={{ mt: 3 }}>
                    <Box component="span" m={1} display="flex" justifyContent="space-between" alignItems="center">
                      <LoadingButton variant="contained" type="submit">
                        Add Dog Training
                      </LoadingButton>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
}

export default AddDogTraining;
